export const getCollapsed = ({ sidebar }) => sidebar.collapsed;
export const getPageKey = ({ sidebar }) => sidebar.currentPage;
